<template>
  <StockForm :stock="$store.state.stocks.stock" :onSubmit="submit"></StockForm>
</template>

<script>
import { mapActions } from 'vuex';
import StockForm from './StockForm.vue';
import { busEvent } from '../../../main';

export default {
  name: 'EditStock',
  components: {
    StockForm,
  },
  created() {
    this.getStock({
      productId: this.$route.params.productId,
      stockId: this.$route.params.stockId,
    });
  },
  methods: {
    ...mapActions('stocks', ['getStock', 'update']),

    async submit() {
      await this.update({
        productId: this.$route.params.productId,
        stockId: this.$route.params.stockId,
      });
      busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
      this.$router.push({
        name: 'Stocuri',
        params: { productId: this.$route.params.productId },
      });
    },
  },
};
</script>
